import React, { useEffect, useState } from "react";
import { useAuth } from "src/App/context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const Dashboard = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const token = user.session.getIdToken().getJwtToken();
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/modules`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!response.ok) throw new Error("Failed to load modules.");
        const data = await response.json();
        setModules(data.modules || []);
      } catch {
        setError("Could not load your modules. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchModules();
  }, [user]);

  const handleOpen = async (mod) => {
    if (opening) return;
    setOpening(mod.moduleId);
    try {
      const jwt = user.session.getIdToken().getJwtToken();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/modules/${mod.moduleId}/access`,
        { method: "POST", headers: { Authorization: `Bearer ${jwt}` } }
      );
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || "Access denied.");
      }
      const { token } = await response.json();
      // Navigate to /view as a full page — needed for Basic Auth credentials in URL
      window.location.href = `/view?token=${encodeURIComponent(token)}`;
    } catch {
      alert("Could not open module. Please contact your Digital Giant representative.");
    } finally {
      setOpening(null);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <p className="greeting">{user?.email}</p>
        <div className="dashboard-nav">
          {user?.role === "admin" && (
            <span className="admin-link" onClick={() => navigate("/admin")}>ADMIN</span>
          )}
          <span className="sign-out" onClick={signOut}>sign out</span>
        </div>
      </div>

      {loading && <div className="dashboard-loading">loading...</div>}
      {error && <p className="dashboard-error">{error}</p>}
      {!loading && !error && modules.length === 0 && (
        <p className="dashboard-empty">
          No modules available. Contact your Digital Giant representative.
        </p>
      )}
      {!loading && modules.length > 0 && (
        <div className="modules-grid">
          {modules.map((mod) => (
            <div
              key={mod.moduleId}
              className={`module-tile${opening === mod.moduleId ? " loading" : ""}`}
              onClick={() => handleOpen(mod)}
            >
              {mod.thumbnail && (
                <div className="module-tile-bg">
                  <img src={mod.thumbnail} alt={mod.name} />
                </div>
              )}
              <div className="module-tile-inner">
                <p className="module-name">{mod.name}</p>
                {mod.description && (
                  <p className="module-description">{mod.description}</p>
                )}
                <p className="module-type">{mod.type || "module"}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
